/** @jsxImportSource @emotion/react */
import React, { ChangeEventHandler, forwardRef } from 'react';
import { css } from '@emotion/react';

interface RadioProps {
  children?: React.ReactNode;
  defaultChecked?: boolean;
  checked?: boolean;
  bold?: boolean;
  prefix?: string;
  value?: string | number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  id?: string;
  className?: string;
}

const Radio = forwardRef<HTMLLabelElement, RadioProps>(
  (
    {
      children,
      onChange,
      checked,
      defaultChecked,
      prefix,
      bold,
      id,
      className,
    },
    ref,
  ) => {
    const RadioStyle = css`
      display: flex;
      label {
        display: inline-flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        .radiobox {
          padding: 0;
          position: relative;
          cursor: pointer;
          align-items: center;
          vertical-align: middle;

          input {
            position: absolute;
            opacity: 0;
          }
          span {
            display: block;
            width: 24px;
            height: 24px;
            border: 1px solid #e1e1e1;
            border-radius: 50%;
          }
          input:checked + span {
            ::after {
              content: ' ';
              border-radius: 50%;
              background: #6079ff;
              position: absolute;
              display: block;
              width: 14px;
              height: 14px;
              left: 50%;
              top: 50%;
              margin-top: -7px;
              margin-left: -7px;
            }
          }
        }
        .inner {
          padding: 0 0 0 12px;
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
        }
      }
      .prefix {
        display: block;
        margin-top: 5px;
        padding-left: 34px;
        font-size: 12px;
        color: #ff1515;
      }
    `;

    return (
      <div css={[RadioStyle]}>
        <label ref={ref}>
          <span className="radiobox">
            <input
              type="radio"
              onChange={onChange}
              checked={checked}
              defaultChecked={defaultChecked}
              id={id}
              className={className}
            />
            <span />
          </span>
          <span className="inner">{children}</span>
        </label>
        {prefix && <span className="prefix">{prefix}</span>}
      </div>
    );
  },
);

export default Radio;
